import React, { FC } from 'react'
import { Grid } from 'semantic-ui-react'
import styled from 'styled-components'
import { LKIcon } from 'loankeeper-common/components'
import { translate } from 'loankeeper-common/helpers'

import { validatePassword } from './validatePassword'

const RuleWrapper = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.28571429rem;
  width: auto;
  color: ${(props) => (props.isPassed ? '' : 'red')};
`

const Rule: FC<{
  label: string
  isPassed: boolean
  rule: string | number
}> = ({ label, isPassed, rule }) => (
  <div className="u-fullWidth u-flex u-pullLeft u-selfCenter">
    <div
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', height: '35px', padding: '5px 0' }}
    >
      <LKIcon alias={isPassed ? 'ok' : 'cancel'} style={{ width: 20, marginRight: 6 }} />
      {label}
      {' : '}
    </div>
    <div style={{ display: 'flex', height: '35px', padding: '5px 0 5px 5px' }}>
      <RuleWrapper isPassed={isPassed}>{rule}</RuleWrapper>
    </div>
  </div>
)

function renderRuleStatus(
  name: string,
  result: ReturnType<typeof validatePassword>,
  label: string,
  rule: string | number,
) {
  if (typeof result[name] === 'undefined') {
    return null
  }

  return <Rule label={label} isPassed={result[name]} rule={rule} />
}

const PasswordValidationResult: FC<any> = ({ result, label, rules, translate }) => {
  return (
    <div className="u-flex u-flexWrap">
      {renderRuleStatus('length', result, translate('lbl_pass_length'), rules.MinLength)}
      {renderRuleStatus('upper', result, translate(label), 'ABCD...')}
      {renderRuleStatus('lower', result, translate(label), 'abcd...')}
      {renderRuleStatus('numbers', result, translate(label), '123...')}
      {renderRuleStatus('special1', result, translate(label), rules.SpecialChars1)}
      {renderRuleStatus('special2', result, translate(label), rules.SpecialChars2)}
    </div>
  )
}

export default PasswordValidationResult
